import { createBackendAPI } from '../../utils/client/backendApi';
import { FintechMmCacheInvalidationGateway } from './fintechMmCacheInvalidationGateway';

const SERVICE_PATH = '/service.sbr';
const SERVICE_NAME = 'CredenciamentoSP.invalidarCachesContrato';
const STATUS_SUCESSO = '1';

function getMgeSession(): string | undefined {
  const fromUrl = new URLSearchParams(window.location.search).get('mgeSession');
  return fromUrl ?? (window as unknown as { mgeSession?: string }).mgeSession;
}

/**
 * Implementacao padrao do `FintechMmCacheInvalidationGateway`: chama o
 * endpoint `fintech@CredenciamentoSP.invalidarCachesContrato` via Service
 * Broker do ERP, reaproveitando `createBackendAPI` (`utils/client/backendApi.ts`)
 * - o mesmo client axios ja usado por `getScoreSummary` e
 * `vendaMaisConfiguracao` para falar com o fintech-mm.
 *
 * Sem parametros - o metodo remoto so faz `.clear()` nos dois caches em
 * memoria, entao pode ser chamado quantas vezes for necessario.
 */
export const serviceBrokerFintechMmCacheInvalidationGateway: FintechMmCacheInvalidationGateway = {
  async invalidateContractCaches(): Promise<void> {
    const api = createBackendAPI('fintech');

    const { data } = await api.post(
      SERVICE_PATH,
      { serviceName: SERVICE_NAME, requestBody: {} },
      { params: { serviceName: SERVICE_NAME, outputType: 'json', mgeSession: getMgeSession() } },
    );

    if (data?.status !== STATUS_SUCESSO) {
      throw new Error(data?.statusMessage || `Falha ao chamar o servico ${SERVICE_NAME} no ERP.`);
    }
  },
};
